import { render, staticRenderFns } from "./detail-solde-de-recuperation-passe-list.vue?vue&type=template&id=08ab0700&scoped=true"
import script from "./detail-solde-de-recuperation-passe-list.vue?vue&type=script&lang=js"
export * from "./detail-solde-de-recuperation-passe-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab0700",
  null
  
)

export default component.exports